import React from "react";
import { Box, Typography, Divider } from "@mui/material";

const Step3IntegrationInstructions = ({ entities }) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Integration Instructions
      </Typography>
      {entities.map((entity, index) => (
        <Box key={index} sx={{ mb: 4 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            {entity.name}
          </Typography>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
            Use the following instructions to integrate sensors for the entity "{entity.name}".
          </Typography>
          {entity.sensors.map((sensor, idx) => {
            const isCameraOrBinary = sensor.sensor_name.toLowerCase().includes("camera") || sensor.sensor_name.toLowerCase().includes("binary");
            const endpoint = isCameraOrBinary ? `/feed/{entityId}/${sensor._id}` : `/data/{entityId}/${sensor._id}`;
            const method = isCameraOrBinary ? "POST" : "PUT";

            return (
              <Box key={idx} sx={{ mb: 3 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                  {sensor.sensor_name}
                </Typography>
                <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                  {sensor.description}
                </Typography>
                <Box sx={{ ml: 2, mb: 2 }}>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <strong>Endpoint:</strong> {endpoint}
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <strong>Method:</strong> {method}
                  </Typography>
                  {isCameraOrBinary ? (
                    <Typography variant="body2">
                      <strong>Payload:</strong> Binary image data
                    </Typography>
                  ) : (
                    <Typography variant="body2">
                      <strong>Payload:</strong> JSON formatted data, e.g.:
                      <pre style={{ background: "#f4f4f4", padding: "8px", borderRadius: "4px" }}>
                        {`{
    "timestamp": "YYYY-MM-DDTHH:mm:ssZ",
    "value": <sensor_reading>
}`}
                      </pre>
                    </Typography>
                  )}
                </Box>
                <Divider />
              </Box>
            );
          })}
        </Box>
      ))}
    </Box>
  );
};

export default Step3IntegrationInstructions;
